export const ProjectIcon = (props) => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Capa_1"
    data-name="Capa 1"
    viewBox="0 0 269.89 300"
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#2e2e2e}"}</style>
    </defs>
    <path
      d="M258.28 286.87c-.35-.66-2.48-2.6-3.02-2.6h-15.25V124.41c0-.66-2.43-3.09-3.09-3.09h-68.83V9.23c0-.88-2.63-2.54-3.37-3.09H37.18c-1.43.98-3.37 2.95-3.37 4.78v273.36H14.64c-.92 0-2.98 2.59-3.65 3.37v2.81c1.43 1.78 2.71 3.59 5.31 3.4l239.28-.28c2.68-1.39 4.28-3.73 2.71-6.7ZM105.73 126.1v158.17H43.36V15.69h115.19v105.63h-49.16c-1.36 0-3.65 3.44-3.65 4.78Zm124.73 158.17H115.27V130.88h115.19v153.39Z"
      className="cls-1"
    />
    <path
      d="M134.94 83.12h-19.67v18.26l.84.84h17.98l.84-.84V83.12ZM86.62 83.12h-19.1v19.1h19.1v-19.1ZM134.94 53.9V35.64l-.84-.84h-17.98l-.84.84V53.9h19.67ZM86.62 130.88h-19.1v19.1h19.1v-19.1ZM86.62 178.64h-19.1v19.1h19.1v-19.1ZM86.62 34.79h-19.1v19.1h19.1v-19.1ZM206.86 216.84v-18.26l-.84-.84h-17.98l-.84.84v18.26h19.67ZM158.54 197.74h-19.1v19.1h19.1v-19.1ZM206.86 246.06h-19.67v18.26l.84.84h17.98l.84-.84v-18.26ZM206.86 149.98h-19.67v19.1h19.67v-19.1ZM158.54 149.98h-19.1v19.1h19.1v-19.1ZM158.54 246.06h-19.1v19.1h19.1v-19.1Z"
      className="cls-1"
    />
  </svg>
)